<div class="bz-empty-state">
  @if (image(); as src) {
    <img
      class="bz-empty-state__image"
      [src]="src"
      [alt]="imageAlt()"
      loading="lazy"
      decoding="async"
    />
  } @else {
    <svg
      class="bz-empty-state__image bz-empty-state__art"
      viewBox="0 0 120 90"
      aria-hidden="true"
      focusable="false"
    >
      <ellipse class="bz-empty-state__art-ground" cx="60" cy="79" rx="23" ry="5" />
      <rect class="bz-empty-state__art-frame" x="26.5" y="10.5" width="67" height="59" rx="8" />
      <rect class="bz-empty-state__art-line" x="40" y="30" width="40" height="7" rx="3.5" />
      <rect class="bz-empty-state__art-line" x="40" y="45" width="26" height="7" rx="3.5" />
    </svg>
  }

  <p class="bz-empty-state__title">{{ title() }}</p>
  @if (description()) {
    <p class="bz-empty-state__description">{{ description() }}</p>
  }
  <div class="bz-empty-state__action"><ng-content /></div>
</div>
